import { render, staticRenderFns } from "./checkmarks.vue?vue&type=template&id=0bf5a96d&scoped=true&"
import script from "./checkmarks.vue?vue&type=script&lang=js&"
export * from "./checkmarks.vue?vue&type=script&lang=js&"
import style0 from "./checkmarks.vue?vue&type=style&index=0&id=0bf5a96d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf5a96d",
  null
  
)

export default component.exports